import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const WebSubHeader = () => import(/* webpackChunkName: "4-feat-websubheader" */ './WebSubHeader');

export default lazyLoadOnRender({ loader: WebSubHeader });
